// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/splash_screen_1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/splash_screen_2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/splash_screen_3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-screen {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: var(--color-white);
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: var(--space-xl);
}

/* Override responsive-container for splash screen */
.splash-screen .responsive-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.splash-screen::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--gradient-splash);
  z-index: 1;
}

.splash-screen.step-1::before {
  display: none;
}

.splash-screen > * {
  position: relative;
  z-index: 2;
}

.splash-screen.step-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.splash-screen.step-1::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    var(--gradient-splash-dark),
    var(--gradient-splash);
  backdrop-filter: blur(var(--blur-md));
  z-index: 1;
}

.splash-screen.step-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.splash-screen.step-2::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    var(--gradient-splash-dark),
    var(--gradient-splash);
  backdrop-filter: blur(var(--blur-md));
  z-index: 1;
}

.splash-screen.step-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.splash-screen.step-3::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    var(--gradient-splash-dark),
    var(--gradient-splash);
  backdrop-filter: blur(var(--blur-md));
  z-index: 1;
}

/* Progress indicators */
.splash-progress {
  display: flex;
  justify-content: center;
  gap: var(--space-sm);
  margin-top: var(--space-2xl);
}

.splash-progress-line {
  height: var(--progress-height);
  border-radius: var(--progress-radius);
  transition: all var(--duration-normal) var(--easing-ease);
  flex: 1 1;
}

.splash-progress-line.active {
  background-color: var(--color-white);
}

.splash-progress-line.inactive {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Main content */
.splash-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
  padding: var(--space-2xl) 0;
}

.splash-title {
  font-family: var(--font-family-semibold);
  font-weight: 600;
  font-size: var(--font-size-5xl);
  line-height: 104%;
  letter-spacing: -4%;
  margin-bottom: var(--space-lg);
  color: var(--color-white);
  white-space: pre-line;
}

.splash-subtitle {
  font-family: var(--font-family-regular);
  font-weight: 400;
  font-size: var(--font-size-xl);
  line-height: 120%;
  letter-spacing: 0%;
  color: var(--color-white);
  white-space: pre-line;
}

/* Text content wrapper */
.splash-text-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* Responsive behavior is handled by the global .responsive-container class */
@media (min-width: 1024px) {
  .splash-screen.step-1::after,
  .splash-screen.step-2::after,
  .splash-screen.step-3::after {
    backdrop-filter: blur(var(--blur-xl)) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Splash/SplashScreen.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;0BAEwB;EACxB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;0BAEwB;EACxB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;0BAEwB;EACxB,qCAAqC;EACrC,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,yDAAyD;EACzD,SAAO;AACT;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;EACE;;;IAGE,gDAAgD;EAClD;AACF","sourcesContent":[".splash-screen {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: var(--color-white);\n  position: relative;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding-top: var(--space-xl);\n}\n\n/* Override responsive-container for splash screen */\n.splash-screen .responsive-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.splash-screen::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--gradient-splash);\n  z-index: 1;\n}\n\n.splash-screen.step-1::before {\n  display: none;\n}\n\n.splash-screen > * {\n  position: relative;\n  z-index: 2;\n}\n\n.splash-screen.step-1 {\n  background-image: url('../../assets/splash_screen_1.png');\n}\n\n.splash-screen.step-1::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    var(--gradient-splash-dark),\n    var(--gradient-splash);\n  backdrop-filter: blur(var(--blur-md));\n  z-index: 1;\n}\n\n.splash-screen.step-2 {\n  background-image: url('../../assets/splash_screen_2.png');\n}\n\n.splash-screen.step-2::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    var(--gradient-splash-dark),\n    var(--gradient-splash);\n  backdrop-filter: blur(var(--blur-md));\n  z-index: 1;\n}\n\n.splash-screen.step-3 {\n  background-image: url('../../assets/splash_screen_3.png');\n}\n\n.splash-screen.step-3::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    var(--gradient-splash-dark),\n    var(--gradient-splash);\n  backdrop-filter: blur(var(--blur-md));\n  z-index: 1;\n}\n\n/* Progress indicators */\n.splash-progress {\n  display: flex;\n  justify-content: center;\n  gap: var(--space-sm);\n  margin-top: var(--space-2xl);\n}\n\n.splash-progress-line {\n  height: var(--progress-height);\n  border-radius: var(--progress-radius);\n  transition: all var(--duration-normal) var(--easing-ease);\n  flex: 1;\n}\n\n.splash-progress-line.active {\n  background-color: var(--color-white);\n}\n\n.splash-progress-line.inactive {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Main content */\n.splash-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: left;\n  padding: var(--space-2xl) 0;\n}\n\n.splash-title {\n  font-family: var(--font-family-semibold);\n  font-weight: 600;\n  font-size: var(--font-size-5xl);\n  line-height: 104%;\n  letter-spacing: -4%;\n  margin-bottom: var(--space-lg);\n  color: var(--color-white);\n  white-space: pre-line;\n}\n\n.splash-subtitle {\n  font-family: var(--font-family-regular);\n  font-weight: 400;\n  font-size: var(--font-size-xl);\n  line-height: 120%;\n  letter-spacing: 0%;\n  color: var(--color-white);\n  white-space: pre-line;\n}\n\n/* Text content wrapper */\n.splash-text-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* Responsive behavior is handled by the global .responsive-container class */\n@media (min-width: 1024px) {\n  .splash-screen.step-1::after,\n  .splash-screen.step-2::after,\n  .splash-screen.step-3::after {\n    backdrop-filter: blur(var(--blur-xl)) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
